import Vue from 'vue'
import App from './App.vue'
import router from './library/index.js'
import axios from 'axios'
import './library/state'
import VueApexCharts from 'vue-apexcharts'
import TrendChart from "vue-trend-chart";
import VueCookies from 'vue-cookies';
import "vue-select/dist/vue-select.css";
Vue.prototype.$axios = axios
// import $ from 'jquery'
import "./style/index.scss"
import './library/GlobalFunctions'
import './library/GeorgianToJalali'
import './library/globalConstants'
import './library/axios.js'
import vSelect from 'vue-select'
import VueAxios from 'vue-axios'
import VueSocialauth from 'vue-social-auth'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar)
Vue.use(VueAxios, axios)
Vue.use(VueSocialauth, {

  providers: {
    google: {
      clientId: '402387793137-nplv9b16m66a8oboe4nchv3o5jkarsnf.apps.googleusercontent.com',
      redirectUri: 'https://anido.ir/auth/google/callback' // Your client app URL
    }
  }
})

Vue.component('apexchart', VueApexCharts)
Vue.use(VueApexCharts)
Vue.use(TrendChart);
Vue.use(VueCookies);
Vue.component("v-select", vSelect);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
